export default __webpack_public_path__ + "static/media/train-station.62d2809f.svg";